import React, { Component } from 'react'

interface Props {
  count: number
}

export default class WorkOrderCount extends Component<Props> {
  render () {
    return (
      <div className="text-[0.675rem] bg-gray-200 text-gray-700 rounded w-fit inline-block px-1">
        {this.props.count} more
      </div>
    )
  }
}
